import SpriteSymbol from "../../../../../doctor/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../doctor/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "IconArrowRight",
  "use": "IconArrowRight-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"IconArrowRight\"><path xmlns=\"http://www.w3.org/2000/svg\" d=\"M12.982 11.846L9.27 15.56a1.25 1.25 0 0 0 1.768 1.767l4.596-4.596a1.25 1.25 0 0 0 0-1.768l-4.596-4.596A1.25 1.25 0 0 0 9.27 8.134l3.712 3.712z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol